import React, { Component } from "react";
import "./Dani.css";
// import { Resizable } from "react-resizable";
// import "react-resizable/css/styles.css";
import { BsArrowUpLeft, BsChevronDoubleLeft } from "react-icons/bs";
class DaniContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width:props.width|| 425,
      height: props.height||420,
    };
  }

  onResize = (event, { node, size, handle }) => {
    this.setState({ width: size.width, height: size.height });
  };
  render() {
    const { opened, minimized, renderInPage } = this.props;
    if (!renderInPage) {
      return ( 
        <div
          height={this.state.height}
          width={this.state.width}
          onResize={this.onResize}
          resizeHandles={["w", "nw"]}
        >
          <div
            className={
              renderInPage ? "dani-container-page p-5 m-5" : "dani-container"
            }
            style={{
              transform: opened  ? "scale(1)" : "scale(0)",
              width:  this.state.width + "px",
              height: minimized ? "40px":this.state.height + "px",
              minWidth: (this.props.minWidth || 425) + "px",
              minHeight:minimized ? "40px": 420 + "px",
             
             
            }}
          >
            {this.props.children}
          </div>
        </div>
      );
    } else {
      return (
        <div
          className={renderInPage ? "dani-container-page" : "dani-container"}
        >
          {this.props.children}
        </div>
      );
    }
  }
}

export default DaniContainer;
